export function mapKeycloakErrorMessage(error: string) {
  const errorCode = error.split(' ')[0];
  if (errorCode === '500') {
    return 'FAILED_TO_SEND_EXECUTION_EMAIL';
  }
  if (errorCode === '409') {
    return 'USER_EXISTS_SAME_USERNAME';
  }
  return 'UNKNOWN_ERROR';
}
